import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.css']
})
export class TransferComponent implements OnInit {

  user_info = this.applicationConstants.user_info;
  user_full_name = '';
  acct_number;
  avail_amount = 0;
  available_amount;
  accts = [];
  user_query = [];
  save_btn = 'تحويل';

  model = {
    'table_name': 'transfer', 'trans_id': '0', 'trans_no': '', 'from_acct': '0', 'to_acct': '0',
    'flag': 'new', 'key': 'trans_id', 'trans_amount': '', 'trans_date': '', 'status': '1', 'comment': '',
    'branch_id': this.applicationConstants.user_branch_info.user_branch_id
  };
  type_model = { 'transfer_type': 'sent', 'trans_date': new Date() };

  Success_Msg; Error_Msg; Transfer; Save; Avail_Trans_Amount_Msg;
  Trans_From_Msg; Trans_To_Msg; Trans_Amount_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<TransferComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Transfer').subscribe((res: string) => {
      this.Transfer = res;
    });
    this.save_btn = this.Transfer;

    translate.get('Save').subscribe((res: string) => {
      this.Save = res;
    });

    translate.get('Avail_Trans_Amount_Msg').subscribe((res: string) => {
      this.Avail_Trans_Amount_Msg = res;
    });

    translate.get('Trans_From_Msg').subscribe((res: string) => {
      this.Trans_From_Msg = res;
    });

    translate.get('Trans_To_Msg').subscribe((res: string) => {
      this.Trans_To_Msg = res;
    });

    translate.get('Trans_Amount_Msg').subscribe((res: string) => {
      this.Trans_Amount_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    this.avail_amount = 0;
    let query = "SELECT `user`.*, `employee`.`name` FROM `user`, `employee` WHERE `user`.`acct_number` ='" + this.user_info.casher_acct_number
      + "' AND `user`.`employee_no` = `employee`.`employee_no`";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.user_query = data.data['list'];
        this.user_full_name = this.user_query['0']['name'];
        this.acct_number = this.user_query['0']['acct_number'];
      });

    let query1 = "SELECT `user`.*, `employee`.`name` FROM `user`, `employee` WHERE `user`.`is_counter` = '1' AND  `user`.`acct_number` <> '" + this.user_info.casher_acct_number
      + "' AND `user`.`employee_no` = `employee`.`employee_no`";
    let obj1 = { cmd: 'getList', query: query1 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.accts = data.data['list'];
      });

    ///////////////////////// EDIT /////////////////////////

    if (this.dialog_data != null) {
      this.save_btn = this.Save;
      this.model = this.dialog_data;
      if (this.model['from_acct'] == this.user_info.casher_acct_number)
        this.type_model['transfer_type'] = 'sent';
      else
        this.type_model['transfer_type'] = 'received';
      this.type_model['trans_date'] = new Date(this.model['trans_date']);

      this.changeAcct(this.type_model['transfer_type']);

      (document.getElementById('transfer_type1') as HTMLInputElement).disabled = true;
      (document.getElementById('transfer_type2') as HTMLInputElement).disabled = true;
    }
    else
      this.changeAcct('sent');

    // if (this.type_model['transfer_type'] == 'sent') {
    //   document.getElementById("from_sent").style.display = 'table-row';
    //   document.getElementById("to_sent").style.display = 'table-row';
    //   //this.available_amount = '1000';
    // }
  }

  // sent() {
  //   this.model['trans_amount'] = '';
  //   document.getElementById("from_sent").style.display = 'table-row';
  //   document.getElementById("to_sent").style.display = 'table-row';
  //   document.getElementById("from_received").style.display = 'none';
  //   document.getElementById("to_received").style.display = 'none';
  //   //this.available_amount = '1000';
  // }

  // received() {
  //   this.model['trans_amount'] = '';
  //   this.model['from_acct'] = '';
  //   document.getElementById("from_sent").style.display = 'none';
  //   document.getElementById("to_sent").style.display = 'none';
  //   document.getElementById("from_received").style.display = 'table-row';
  //   document.getElementById("to_received").style.display = 'table-row';
  //   //this.available_amount = '';

  // }

  changeAcct(type) {
    let acct_number;
    if (type == 'sent')
      acct_number = this.user_info.casher_acct_number;
    else
      acct_number = this.model['from_acct'];

    if (type == 'received' && acct_number == '0') {
      this.avail_amount = 0;
      this.available_amount = '';
    }

    else {
      let obj = { cmd: 'getAcctBalance', acct_number: acct_number, acct_type: 'acct' };

      this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.avail_amount = data.status['msg'];
          this.available_amount = this.utils.numberFormat(data.status['msg']);
          // console.log(this.avail_amount);
          if (this.model['flag'] == 'update')
            this.available_amount = (Number(this.avail_amount) + Number(this.model['trans_amount'])).toFixed(2);
        });
    }
  }

  add() {
    if (this.type_model['transfer_type'] == 'sent')
      this.model['from_acct'] = this.user_info.casher_acct_number;

    else if (this.type_model['transfer_type'] == 'received') {
      this.model['to_acct'] = this.user_info.casher_acct_number;
      this.model['status'] = '2';
    }

    if (this.model['from_acct'] != '' && this.model['to_acct'] != '' && this.model['trans_amount'] != '') {
      this.model['trans_amount'] = this.model['trans_amount'].replace(/,/g, '');
      let check_amount = this.avail_amount - Number(this.model['trans_amount']);
      if (check_amount >= 0) {
        this.model['trans_date'] = (this.type_model['trans_date'].getFullYear() + "-" +
          (this.type_model['trans_date'].getMonth() + 1) + "-" + this.type_model['trans_date'].getDate() + ' ' +
          (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':' + (new Date()).getSeconds());

        let values = [];
        values.push(this.model);
        console.log(values);
        
        let obj;
        if (this.model['trans_id'] == '0' || this.model['flag'] == 'new') {
          let year = this.type_model['trans_date'].getFullYear();
          let prefix = this.applicationConstants.user_branch_info.user_branch_id + "-" + year + "-";

          obj = { cmd: 'add', values: values, pk: 'trans_no', id: 'trans_id', main_table: 'transfer', 
            prefix: prefix };
        }
        else
          obj = { cmd: 'updateAdv', values: values };

        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(this.Success_Msg);
              this.dialog_data = { 'op_type': 'success' };
              this.dialogRef.close(this.dialog_data);
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
      else
        alert(this.Avail_Trans_Amount_Msg);
    }
    else if (this.model['from_acct'] == '')
      alert(this.Trans_From_Msg);

    else if (this.model['to_acct'] == '')
      alert(this.Trans_To_Msg);

    else if (this.model['trans_amount'] == '')
      alert(this.Trans_Amount_Msg);
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
